import React, { memo } from 'react'
import { Avatar, Link } from '@mui/material'

import { VIP_CLUB_URL } from '../../constants/app'

const PerkIcon = ({ src, icon, size = 64, sx, variant = '' }) => {
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        ...sx
      }}
      slotProps={{
        img: {
          loading: 'lazy'
        }
      }}
      src={src}
      variant={variant}
      component={Link}
      href={`${VIP_CLUB_URL}/membership`}
      target='_blank'
    >
      {icon && icon}
    </Avatar>
  )
}

export default memo(PerkIcon)
